import React from 'react';
import { motion } from "framer-motion";
import { useHistory } from "react-router-dom";
import { onDragEnd, getGoal, checkConditions } from "../resources/utils";

import styles from './Tiers.module.scss';

import TierCard from "../components/TierCard";
import ProductBannerCard from "../components/ProductBannerCard";
import ProductCard from "../components/ProductCard";
import Welcomer from "../components/Welcomer";

const variants = {
  enter: {
    x: -1000,
    opacity: 0
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: {
    zIndex: 0,
    x: 1000,
    opacity: 0
  }
};

const Tiers = ({ config, customer, rewards, tiers }) => {
  let history = useHistory();

  let tierRewards = customer ? [ ...customer.tiers ].reduce((result, tierId) => {
    let newResult = [ ...result ];
    let tier = config.tiers.find(x => x.id === tierId);
    if(tier && tier.rewards) {
      for (var i = 0; i < tier.rewards.length; i++) {
        let loopId = tier.rewards[i];
        let reward = rewards.find(x => x.id === loopId);
        let rewardIndex = newResult.findIndex(x => x.id === loopId);
        if(reward && rewardIndex === -1 && reward.discount.__typename !== 'SystemDiscount') {
          if(checkConditions(reward.conditions, customer)) {
            newResult.push(reward);
          }
        }
      }
    }
    return newResult;
  }, []) : [];

  let tiersReversed = [ ...config.tiers ].reverse();
  let highestTier = tiersReversed.find(x => ( tiers.some(z => z.id === x.id) && customer.tiers.includes(x.id))); // Find our highest tier the customer has, checking that it's a valid tier as well.
  let nextTierIndex = tiersReversed.findIndex((o, i) => ((i+1 !== tiersReversed.length) && tiersReversed[i+1] && tiersReversed[i+1].id === highestTier.id) );

  let highestTierData = tiers.find(x => x.id === highestTier.id);
  let nextTierData = (nextTierIndex !== -1) ? tiers.find(x => x.id === tiersReversed[nextTierIndex].id) : null;


  let goalData = nextTierData ? getGoal(highestTierData.conditions, nextTierData.conditions) : null;
  let goalPercentComplete = null;
  let goalField = null;
  let goalProgress = null;
  if(goalData && goalData.field === 'lifetimePoints') {
    goalPercentComplete = (+customer.lifetimePoints - goalData.oldTarget) / (goalData.newTarget - goalData.oldTarget) * 100;
    goalField = 'Points';
    goalProgress = +customer.lifetimePoints;
  }
  if(goalData && goalData.field === 'points') {
    goalPercentComplete = (+customer.points - goalData.oldTarget) / (goalData.newTarget - goalData.oldTarget) * 100;
    goalField = 'Points';
    goalProgress = +customer.points;
  }
  if(goalData && goalData.field === 'lifetimeSpend') {
    goalPercentComplete = (+customer.lifetimeSpend - goalData.oldTarget) / (goalData.newTarget - goalData.oldTarget) * 100;
    goalField = 'Spend';
    goalProgress = +customer.lifetimeSpend;
  }
  if(goalData && goalData.field === 'lifetimeOrders') {
    goalPercentComplete = (+customer.lifetimeOrders - goalData.oldTarget) / (goalData.newTarget - goalData.oldTarget) * 100;
    goalField = 'Orders';
    goalProgress = +customer.lifetimeOrders;
  }

  return (
    <motion.div
    className={styles.tiers}
    data-has-footer={customer && customer.accountEnabled}
    variants={variants}
    initial="enter"
    animate="center"
    exit="exit"
    transition={{
      x: { type: "spring", stiffness: 300, damping: 30 },
      opacity: { duration: 0.2 }
    }}
    drag="x"
    dragConstraints={{ left: 0, right: 0 }}
    dragElastic={0.5}
    onDragEnd={(e, { offset, velocity }) => {
      onDragEnd(
        offset,
        velocity,
        () => {
          history.goBack();
        },
        () => {
          // do nothing
        },
      )
    }}
    >
      {
        customer && customer.accountEnabled &&
        <Welcomer logo={config.logo} customer={customer} />
      }
      <div onClick={() => { history.goBack(); }} className={styles.breadcrumb}>
        <svg width="17" height="9" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.19752 0.123583L5.46584 0.372138C5.64366 0.53688 5.64366 0.803996 5.46584 0.968773L2.28107 3.90235H16.5446C16.7961 3.90235 17 4.09124 17 4.32422V4.67579C17 4.90877 16.7961 5.09766 16.5446 5.09766H2.28107L5.46584 8.03124C5.64366 8.19598 5.64366 8.46309 5.46584 8.62787L5.19752 8.87643C5.0197 9.04117 4.73139 9.04117 4.55357 8.87643L0.133383 4.7983C-0.0444355 4.63356 -0.0444355 4.36645 0.133383 4.20167L4.55357 0.123583C4.73139 -0.0411943 5.0197 -0.0411943 5.19752 0.123583Z" fill="#1D1D1E"/>
        </svg>
        <span>Benefits</span>
      </div>

      <div className={styles.yourtier}>
        {
          highestTier &&
          <TierCard id={highestTier.id} accent={highestTier.accent} perks={highestTier.perks} image={highestTier.image} />
        }
      </div>

      {/*
        Tier Rewards section
      */}

      {
        (tierRewards && tierRewards.length !== 0) &&
        <div className={styles.rewards}>
          <strong>Tier rewards</strong>
          {
            tierRewards.map(x => {
              let rewardCard = config.rewards.find(z => z.id === x.id);
              let rewardObj = x;
              if(rewardCard && rewardObj) {
                if(x.banner) {
                  return <ProductBannerCard key={x.id} image={x.bannerImage} title={rewardCard.title} points={rewardObj.points} id={x.id} buttonText={x.bannerButtonText} buttonColour={x.bannerButtonColour} buttonTextColour={x.bannerButtonTextColour} textColour={x.bannerTextColour }/>
                }
                return <ProductCard key={x.id} image={rewardCard.image} title={rewardCard.title} points={rewardObj.points} id={x.id} />
              } else {
                return <div key={x.id}></div>
              }
            })
          }
        </div>
      }

      {
        (goalPercentComplete !== null && goalField !== null) &&
        <div className={styles.nextTier}>
          <div className={styles.ntHeader}>
            <div>To upgrade to <span style={{ color: tiersReversed[nextTierIndex].accent ? `#${tiersReversed[nextTierIndex].accent}` : undefined }}>{ tiersReversed[nextTierIndex].name }</span></div>
          </div>
          <div className={styles.ntBar}>
            <div style={{ width: `${goalPercentComplete.toFixed(2)}%`, backgroundColor: tiersReversed[nextTierIndex].accent ? `#${tiersReversed[nextTierIndex].accent}` : undefined }}>
            </div>
          </div>
          <div className={styles.ntFooter}>
            <div>
              <span>{ goalProgress }</span>
              <span>{`${goalField} earned`}</span>
            </div>
            <div>
              <span>{ goalData.newTarget }</span>
              <span>{`${goalField} needed`}</span>
            </div>
          </div>
        </div>
      }
      <div className={styles.tierlist}>
        <strong>George Rewards tiers</strong>
        {
          config.tiers.map(x => {
            return <TierCard key={x.id} id={x.id} title={x.title} accent={x.accent} perks={x.perks} image={x.image} />
          })
        }
      </div>
    </motion.div>
  )
}

export default Tiers;
